export const AUTH_TOKEN_KEY = 'token-user'
export const AUTH_USER_KEY = 'logged-user'

let httpClient = null
let authExpiredHandler = null

export function bindAxios(axios) {
  httpClient = axios
}

export function registerAuthExpiredHandler(handler) {
  authExpiredHandler = handler
}

export function parseJsonStorage(key, fallback) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw)
  } catch {
    localStorage.removeItem(key)
    return fallback
  }
}

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY) || ''
}

export function isAuthenticated() {
  return !!getAuthToken()
}

export function syncAxiosAuthToken() {
  if (!httpClient) return
  const token = getAuthToken()
  if (token) {
    httpClient.defaults.headers.common.Auth = token
  } else {
    delete httpClient.defaults.headers.common.Auth
  }
}

export function setAuthSession(token, loggedUser) {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
  }
  if (loggedUser) {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(loggedUser))
  }
  localStorage.removeItem('token')
  syncAxiosAuthToken()
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(AUTH_USER_KEY)
  localStorage.removeItem('token')
  syncAxiosAuthToken()
}

export function isAuthError(error) {
  if (!error) return false

  const status = error.networkError?.statusCode
    || error.networkError?.status
    || error.response?.status

  if (status === 401 || status === 403) return true

  const gqlErrors = error.graphQLErrors || []
  return gqlErrors.some((e) => {
    const message = (e.message || '').toLowerCase()
    const category = (e.extensions?.category || '').toLowerCase()
    return message.includes('unauthenticated')
      || message.includes('unauthorized')
      || message.includes('not authenticated')
      || category === 'authentication'
  })
}

export function isNetworkError(error) {
  if (!error) return false
  if (error.networkError && !isAuthError(error)) return true
  const message = (error.message || '').toLowerCase()
  return message.includes('network error')
    || message.includes('failed to fetch')
    || message.includes('timeout')
}

export function handleAuthExpired() {
  if (typeof authExpiredHandler === 'function') {
    authExpiredHandler()
  }
}

export function routeRequiresAuth(route) {
  return route.matched.some((record) => record.meta.requiresAuth)
}

export function isPublicAuthRoute(path) {
  return path === '/login' || path === '/logout'
}
